import React from "react";
import { Select } from "antd";
const { Option } = Select;
const SelectComponent = (props) => {
  return (
    <div className="select-wrap">
      <label>{props.label}</label>
      <Select
        placeholder={props.placeholder ? props.placeholder : "Select Option"}
        onChange={props.onChange}
        value={props.value}
        allowClear
        showSearch={props.search}
        onClear={props.onClear}
        mode={props.mode}
      >
        {props.options.map((ele) => (
          <Option key={ele.value} value={ele.value}>
            {ele.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectComponent;
